import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceViewsEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceViewsEligibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"offering"}},{"kind":"Field","name":{"kind":"Name","value":"premiumFeatures"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceViewsEligibility","document":WorkspaceViewsEligibilityDocument}} as const;
export type WorkspaceViewsEligibilityQueryVariables = Types.Exact<{
  orgId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type WorkspaceViewsEligibilityQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'name' | 'offering' | 'premiumFeatures'>
  )> }
);

/**
 * __useWorkspaceViewsEligibilityQuery__
 *
 * To run a query within a React component, call `useWorkspaceViewsEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceViewsEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceViewsEligibilityQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useWorkspaceViewsEligibilityQuery(
  baseOptions?: TrelloQueryHookOptions<
    WorkspaceViewsEligibilityQuery,
    WorkspaceViewsEligibilityQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspaceViewsEligibilityDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspaceViewsEligibilityQuery,
    WorkspaceViewsEligibilityQueryVariables
  >(WorkspaceViewsEligibilityDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspaceViewsEligibilityLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspaceViewsEligibilityQuery,
    WorkspaceViewsEligibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceViewsEligibilityQuery,
    WorkspaceViewsEligibilityQueryVariables
  >(WorkspaceViewsEligibilityDocument, options);
}
export function useWorkspaceViewsEligibilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        WorkspaceViewsEligibilityQuery,
        WorkspaceViewsEligibilityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkspaceViewsEligibilityQuery,
    WorkspaceViewsEligibilityQueryVariables
  >(WorkspaceViewsEligibilityDocument, options);
}
export type WorkspaceViewsEligibilityQueryHookResult = ReturnType<
  typeof useWorkspaceViewsEligibilityQuery
>;
export type WorkspaceViewsEligibilityLazyQueryHookResult = ReturnType<
  typeof useWorkspaceViewsEligibilityLazyQuery
>;
export type WorkspaceViewsEligibilitySuspenseQueryHookResult = ReturnType<
  typeof useWorkspaceViewsEligibilitySuspenseQuery
>;
export type WorkspaceViewsEligibilityQueryResult = Apollo.QueryResult<
  WorkspaceViewsEligibilityQuery,
  WorkspaceViewsEligibilityQueryVariables
>;
